import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const FEEDBACK_TRACKING_SCHEMA = Object.freeze({});
const RECORD = generateSchema(FEEDBACK_TRACKING_SCHEMA);
const KEYS: any = generateKeys(FEEDBACK_TRACKING_SCHEMA);

export class FeedbackTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.feedback;
  }

  get properties() {
    return this.toJS();
  }
}
